var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 650,
    height: 650,
    viewBox: "0 0 650 650",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_126_5851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1084 0H-156.724V650H1084V0Z",
    fill: "#B22234"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-156.724 75H1084ZM1084 175H-156.724ZM-156.724 275H1084ZM1084 375H-156.724ZM-156.724 475H1084ZM1084 575H-156.724Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-156.724 75H1084M1084 175H-156.724M-156.724 275H1084M1084 375H-156.724M-156.724 475H1084M1084 575H-156.724",
    stroke: "white",
    strokeWidth: 50
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.567 0H-156.724V350H339.567V0Z",
    fill: "#3C3B6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70601 50L20.5162 86.1803L-10.4033 63.8197H27.8153L-3.1042 86.1803L8.70601 50Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70601 120L20.5162 156.18L-10.4033 133.82H27.8153L-3.1042 156.18L8.70601 120Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70601 190L20.5162 226.18L-10.4033 203.82H27.8153L-3.1042 226.18L8.70601 190Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70601 260L20.5162 296.18L-10.4033 273.82H27.8153L-3.1042 296.18L8.70601 260Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0644 15L61.8746 51.1803L30.9551 28.8197H69.1737L38.2542 51.1803L50.0644 15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0644 85L61.8746 121.18L30.9551 98.8197H69.1737L38.2542 121.18L50.0644 85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0644 155L61.8746 191.18L30.9551 168.82H69.1737L38.2542 191.18L50.0644 155Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0644 225L61.8746 261.18L30.9551 238.82H69.1737L38.2542 261.18L50.0644 225Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0644 295L61.8746 331.18L30.9551 308.82H69.1737L38.2542 331.18L50.0644 295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4218 50L103.232 86.1803L72.3125 63.8197H110.531L79.6116 86.1803L91.4218 50Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4218 120L103.232 156.18L72.3125 133.82H110.531L79.6116 156.18L91.4218 120Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4218 190L103.232 226.18L72.3125 203.82H110.531L79.6116 226.18L91.4218 190Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4218 260L103.232 296.18L72.3125 273.82H110.531L79.6116 296.18L91.4218 260Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.779 15L144.589 51.1803L113.67 28.8197H151.889L120.969 51.1803L132.779 15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.779 85L144.589 121.18L113.67 98.8197H151.889L120.969 121.18L132.779 85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.779 155L144.589 191.18L113.67 168.82H151.889L120.969 191.18L132.779 155Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.779 225L144.589 261.18L113.67 238.82H151.889L120.969 261.18L132.779 225Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.779 295L144.589 331.18L113.67 308.82H151.889L120.969 331.18L132.779 295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.137 50L185.947 86.1803L155.027 63.8197H193.246L162.326 86.1803L174.137 50Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.137 120L185.947 156.18L155.027 133.82H193.246L162.326 156.18L174.137 120Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.137 190L185.947 226.18L155.027 203.82H193.246L162.326 226.18L174.137 190Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.137 260L185.947 296.18L155.027 273.82H193.246L162.326 296.18L174.137 260Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.494 15L227.304 51.1803L196.385 28.8197H234.603L203.684 51.1803L215.494 15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.494 85L227.304 121.18L196.385 98.8197H234.603L203.684 121.18L215.494 85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.494 155L227.304 191.18L196.385 168.82H234.603L203.684 191.18L215.494 155Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.494 225L227.304 261.18L196.385 238.82H234.603L203.684 261.18L215.494 225Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.494 295L227.304 331.18L196.385 308.82H234.603L203.684 331.18L215.494 295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.852 50L268.662 86.1803L237.742 63.8197H275.961L245.041 86.1803L256.852 50Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.852 120L268.662 156.18L237.742 133.82H275.961L245.041 156.18L256.852 120Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.852 190L268.662 226.18L237.742 203.82H275.961L245.041 226.18L256.852 190Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.852 260L268.662 296.18L237.742 273.82H275.961L245.041 296.18L256.852 260Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.21 15L310.02 51.1803L279.101 28.8197H317.319L286.4 51.1803L298.21 15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.21 85L310.02 121.18L279.101 98.8197H317.319L286.4 121.18L298.21 85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.21 155L310.02 191.18L279.101 168.82H317.319L286.4 191.18L298.21 155Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.21 225L310.02 261.18L279.101 238.82H317.319L286.4 261.18L298.21 225Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.21 295L310.02 331.18L279.101 308.82H317.319L286.4 331.18L298.21 295Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_126_5851"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 650,
    height: 650,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsFlag);
export default __webpack_public_path__ + "static/media/usFlag.e85e66f69a20153e010af2539815e36f.svg";
export { ForwardRef as ReactComponent };